import React from 'react';

export interface FormFieldProps {
  label?: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
  /**
   * Acao opcional renderizada inline a direita do label (ex.: link
   * "Esqueci minha senha" alinhado com o label "Senha *"). Usa flex
   * com space-between via `.field__label-row`.
   */
  labelAction?: React.ReactNode;
}

export function FormField({
  label,
  error,
  helperText,
  required,
  htmlFor,
  children,
  className,
  labelAction,
}: FormFieldProps) {
  return (
    <div className={`field${className ? ` ${className}` : ''}`}>
      {(label || labelAction) && (
        <div className={`field__label-row${labelAction ? ' field__label-row--with-action' : ''}`}>
          {label && (
            <label className="field__label" htmlFor={htmlFor}>
              {label}
              {required && <span className="req" aria-hidden="true">*</span>}
            </label>
          )}
          {labelAction && <span className="field__label-action">{labelAction}</span>}
        </div>
      )}
      {children}
      {error && (
        <div className="field__error" role="alert">
          {error}
        </div>
      )}
      {helperText && !error && <div className="field__hint">{helperText}</div>}
    </div>
  );
}
